import logger from '../../utils/logger';
import { NotificationType } from '../../contexts/NotificationContext';

interface PrintViewParams {
  elementToCapture: HTMLElement;
  jobTitle: string;
  mainCssUrl: string;
  headerContent: string;
  showNotification: (message: string, type?: NotificationType, duration?: number) => void;
}

export const openPrintView = (params: PrintViewParams): void => {
  const {
    elementToCapture,
    jobTitle,
    mainCssUrl,
    headerContent,
    showNotification,
  } = params;

  if (!elementToCapture) {
    showNotification('No specific view element found to print.', 'warning');
    return;
  }

  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.write(`
      <html>
      <head>
        <title>${jobTitle}</title>
       <link rel="stylesheet" href="${mainCssUrl}"> <!-- Your app's main styles -->
        <link rel="stylesheet" href="/printStyles.css"> <!-- Link to the new print-specific styles -->
      </head>
      <body>
        <div class="print-header-manual">${headerContent}</div>  
        <div class="print-content">${elementToCapture.innerHTML}</div>
        <div class="print-footer-manual">
            Created with love by <bold>Deriq.AI</bold> on&nbsp;
            ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}
        </div>
      </body>
      </html>
    `);

    logger.info( "Printing to window");
    printWindow.document.close();
    
    setTimeout(() => {
      printWindow.print();
    }, 250);
  } else {
    showNotification('Could not open print window. Please check your browser pop-up blockers.', 'error');
  }
};